module.exports = __webpack_public_path__ + "img/TDSouthAfrica-logo-new.e4ee9203.png";